import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgAccountModalOffers',
})
export default class CmgAccountModalOffers extends Vue {
    get medallionRewardShout(): string {
        return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
    }

    get headingExplanationText(): string {
        return this.numPromotions > 0 ? 'Ready to use' : 'Nothing available at the moment';
    }

    get numPromotions(): number {
        return this.$appStore.state.customer.wallet.promotions.length;
    }

    async mounted(): Promise<void> {
        try {
            await this.$services.promotions.refreshCustomerPromotions();
        } catch (e: any) {
            this.$services.logger.error('Something went wrong while fetching customer promotions: ', e);
        } 
    }

    onClickMyOffers() {
        this.$router.push({ name: Routes.Offers });
        this.close();
    }

    close() {
        this.$services.ui.setModalVisibility('account', false);
        this.$services.ui.focusBack();
    }
}
